import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Container, Row, Col, Image , Button} from "react-bootstrap";
import { RightArrow } from "../../svgIcon";
import "./_search-page.scss";

function SearchResult() {

    const navigate = useNavigate();
    const location = useLocation();
    const [searchResult, setSearchResult] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!location.state?.fromSubmission) {
            navigate("/");
        } else {
            window.history.replaceState({}, document.title);
            setSearchResult(location.state?.result);
            setIsLoading(false);
        }
    }, [location, navigate]);

    if (isLoading) {
        return <div></div>;
    }

    // console.log(searchResult.searchresult);
    return (
        <>
            <section className=" inner-page-gap search-page" data-aos="fade">
                <Container>
                    <Row className="justify-content-center">
                        {
                            searchResult?.searchresult?.searchResults && searchResult?.searchresult?.searchResults?.length > 0 ? (
                                searchResult?.searchresult?.searchResults && searchResult?.searchresult?.searchResults?.map((item) => {
                                    let DetailPageUrl = '';
                                    if (item?.pageAlias) {
                                        DetailPageUrl = '/' + item?.pageAlias;
                                    }
                                    if (item?.slug && item?.slug != 'na' && item?.slug != '') {
                                        DetailPageUrl += '/' + item?.slug;
                                    }
                                    return (
                                        <>
                                            {
                                                DetailPageUrl != '' ? (
                                                    <>
                                                    <Col lg={10}>
                                                        <div className="item">
                                                            <Row className="align-items-center justify-content-between">
                                                                <Col sm={9} xs={10}>
                                                                    <h5 className="title mb-2"><Link to={DetailPageUrl} title={item?.term}>{item?.term}</Link></h5>
                                                                    {
                                                                        item?.varShortDescription ? (<>
                                                                            <p className="dis">{item?.varShortDescription}</p>
                                                                        </>) : ''
                                                                    }
                                                                </Col>
                                                                <Col sm={3} xs={2} className="text-end">
                                                                    <Link to={DetailPageUrl} title={item?.term} className="link-button"><i className="icon"><RightArrow/></i></Link>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                    </>
                                                ) : (
                                                    <>
                                                        {item?.term}
                                                    </>
                                                )
                                            }
                                        </>
                                    );
                                })
                            ) : (
                                <>
                                <h4 className="mb-4">Search Results for <span className="result">{searchResult?.searchresult?.searchTerm}</span></h4>
                                {searchResult?.searchresult?.searchTerm ? (
                                    <p>About {searchResult?.searchresult?.searchFoundCounter} results</p>
                                ) : ''}
                                </>
                            )
                        }
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default SearchResult;